var map = {
	"./icon-arrow-down.svg": "./src/copy/images/icons/icon-arrow-down.svg",
	"./icon-arrow-external.svg": "./src/copy/images/icons/icon-arrow-external.svg",
	"./icon-arrow-right-long.svg": "./src/copy/images/icons/icon-arrow-right-long.svg",
	"./icon-arrow.svg": "./src/copy/images/icons/icon-arrow.svg",
	"./icon-bitchute.svg": "./src/copy/images/icons/icon-bitchute.svg",
	"./icon-bullet-filled-power.svg": "./src/copy/images/icons/icon-bullet-filled-power.svg",
	"./icon-bullet-power.svg": "./src/copy/images/icons/icon-bullet-power.svg",
	"./icon-burger-close.svg": "./src/copy/images/icons/icon-burger-close.svg",
	"./icon-burger.svg": "./src/copy/images/icons/icon-burger.svg",
	"./icon-check-large.svg": "./src/copy/images/icons/icon-check-large.svg",
	"./icon-check.svg": "./src/copy/images/icons/icon-check.svg",
	"./icon-chevron-down.svg": "./src/copy/images/icons/icon-chevron-down.svg",
	"./icon-chevron.svg": "./src/copy/images/icons/icon-chevron.svg",
	"./icon-close-simple.svg": "./src/copy/images/icons/icon-close-simple.svg",
	"./icon-close.svg": "./src/copy/images/icons/icon-close.svg",
	"./icon-facebook.svg": "./src/copy/images/icons/icon-facebook.svg",
	"./icon-instagram.svg": "./src/copy/images/icons/icon-instagram.svg",
	"./icon-itunes.svg": "./src/copy/images/icons/icon-itunes.svg",
	"./icon-microphone.svg": "./src/copy/images/icons/icon-microphone.svg",
	"./icon-minus.svg": "./src/copy/images/icons/icon-minus.svg",
	"./icon-pause.svg": "./src/copy/images/icons/icon-pause.svg",
	"./icon-play.svg": "./src/copy/images/icons/icon-play.svg",
	"./icon-player-previous.svg": "./src/copy/images/icons/icon-player-previous.svg",
	"./icon-plus.svg": "./src/copy/images/icons/icon-plus.svg",
	"./icon-podbean.svg": "./src/copy/images/icons/icon-podbean.svg",
	"./icon-power-waves.svg": "./src/copy/images/icons/icon-power-waves.svg",
	"./icon-quote.svg": "./src/copy/images/icons/icon-quote.svg",
	"./icon-search.svg": "./src/copy/images/icons/icon-search.svg",
	"./icon-soundcloud.svg": "./src/copy/images/icons/icon-soundcloud.svg",
	"./icon-spotify.svg": "./src/copy/images/icons/icon-spotify.svg",
	"./icon-star-bullet-red.svg": "./src/copy/images/icons/icon-star-bullet-red.svg",
	"./icon-star-bullet.svg": "./src/copy/images/icons/icon-star-bullet.svg",
	"./icon-star-outline-bullet.svg": "./src/copy/images/icons/icon-star-outline-bullet.svg",
	"./icon-telegram.svg": "./src/copy/images/icons/icon-telegram.svg",
	"./icon-tiktok.svg": "./src/copy/images/icons/icon-tiktok.svg",
	"./icon-tip.svg": "./src/copy/images/icons/icon-tip.svg",
	"./icon-volume.svg": "./src/copy/images/icons/icon-volume.svg",
	"./icon-waves.svg": "./src/copy/images/icons/icon-waves.svg",
	"./icon-youtube.svg": "./src/copy/images/icons/icon-youtube.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/copy/images/icons sync ^\\.\\/.*\\.svg$";